import { useEffect } from "react";

export default function Privacy() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://app.termly.io/embed-policy.min.js";
    script.id = "termly-jssdk";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="terms-container">
      <div
        name="termly-embed"
        data-id="1c98fc35-bc23-42e4-813f-2b0ae0a2f563"
      ></div>
    </div>
  );
}
